'use strict';

angular.module('adminDefaultEntitlementControllers', [
    'ngAnimate',
    'ui.bootstrap',
    'mgcrea.ngStrap',
    'services.administrationDefaultEntitlement'
]);

